import { useState } from "react";
import styles from "./TwoFactorSelectionForm.module.css";
import CareHiresLogo from "../../../assets/img/CH_New_Logo.png";
import { Card, Col, Radio, Row, Select } from "antd";
import BlackBusinessman from "../../../assets/img/BlackBusinessman.svg";
import TotpVerificationForm from "./totp/TotpVerificationForm";
import SmsVerificationForm from "./sms/SmsVerificationForm";

const TwoFactorSelectionForm = (props: any) => {
  const [selectedMfaMethod, setSelectedMfaMethod] = useState<
    null | "totp" | "phone"
  >(null);
  const userEmail = props.userEmail;
  const userPhone = props.userPhone;
  const resolver = props.resolver;
  return (
    <div>
      {selectedMfaMethod !== "totp" && selectedMfaMethod !== "phone" && (
        <div className={styles["login-container"]}>
          <img
            className="login-title"
            src={CareHiresLogo}
            alt="CareHires Logo"
          />
          <Row justify="center" align="middle">
            <Col md={24}>
              <Card bordered={false} className={styles["login-card"]}>
                <h3 className={styles["sign-in-heading"]}>
                  Multi-Factor Authentication
                </h3>
                <p className={styles["mfa-description"]}>
                  To help keep your account safe, Care Hires wants to
                </p>
                <p className={styles["mfa-description"]}>
                  make sure that it's really you trying to sign in
                </p>
                <div className="row d-flex justify-content-center">
                  <div className="col-md-10 d-flex justify-content-center">
                    <div className={styles["email-container"]}>
                      <p>{userEmail}</p>
                    </div>
                  </div>
                </div>
                <img
                  src={BlackBusinessman}
                  className="login-logo"
                  alt="logo"
                  style={{ height: "12rem", width: "12rem" }}
                />
                <Row justify="center" align="middle">
                  <Card
                    style={{
                      width: "100%",
                      display: "flex",
                      alignContent: "flex-start",
                    }}
                  >
                    <h6 className={styles["confirm-phone-code-heading"]}>
                    Select One of the Following MFA Methods
                    </h6>
                    <Radio.Group
                      options={[
                        { value: "totp", label: "Authenticator App" },
                        { value: "phone", label: "Sms  Method" },
                      ]}
                      onChange={(e) => setSelectedMfaMethod(e.target.value)}
                    />
                  </Card>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>
      )}
      {selectedMfaMethod === "totp" && (
        <TotpVerificationForm resolver={resolver} redirectUrl={props.redirectUrl} extractPageName={props.extractPageName} handleWorkerOrMobileLogin={props.handleWorkerOrMobileLogin}/>
      )}
      {selectedMfaMethod === "phone" && (
        <SmsVerificationForm
          resolver={resolver}
          userEmail={userEmail}
          userPhone={userPhone}
          redirectUrl={props.redirectUrl}
          extractPageName={props.extractPageName}
          handleWorkerOrMobileLogin={props.handleWorkerOrMobileLogin}
        />
      )}
    </div>
  );
};

export default TwoFactorSelectionForm;
